export const sizeList = [
  {
    name: '肩宽',
    code: '1001'
  },
  {
    name: '横宽',
    code: '1002'
  },
  {
    name: '衣长',
    code: '1003'
  },
  {
    name: '袖长',
    code: '1004'
  },
  {
    name: '袖宽',
    code: '1005'
  },
  {
    name: '袖口宽',
    code: '1006'
  },
  {
    name: '连肩袖长度',
    code: '1007'
  },
  {
    name: '领围',
    code: '1008'
  },
  {
    name: '腰围',
    code: '1009'
  },
  {
    name: '臀围',
    code: '1010'
  },
  {
    name: '前档长',
    code: '1011'
  },
  {
    name: '后档长',
    code: '1012'
  },
  {
    name: '裤脚宽',
    code: '1013'
  },
  {
    name: '大腿根围',
    code: '1014'
  },
  {
    name: '半身裙',
    code: '1015'
  },
  {
    name: '裙长',
    code: '1016'
  },
  {
    name: '连衣裙',
    code: '1017'
  },
  {
    name: '后衣长',
    code: '1018'
  },
  {
    name: '头围（内侧）',
    code: '1019'
  },
  {
    name: '高度',
    code: '1020'
  },
  {
    name: '肩带',
    code: '1021'
  },
  {
    name: '下胸围',
    code: '1022'
  },
  {
    name: '长度',
    code: '1023'
  },
  {
    name: '最大宽度',
    code: '1024'
  },
  {
    name: '跟高',
    code: '1025'
  },
  {
    name: '鞋底宽',
    code: '1026'
  },
  {
    name: '鞋底的长度(有鞋跟的商品除外)',
    code: '1027'
  },
  {
    name: '鞋前宽',
    code: '1028'
  },
  {
    name: '脚踝围(外侧)',
    code: '1029'
  },
  {
    name: '筒围(内侧)',
    code: '1030'
  },
  {
    name: '鞋底高度',
    code: '1031'
  },
  {
    name: '宽度',
    code: '1032'
  },
  {
    name: '裤长',
    code: '1033',
    isSpecial: 1
  },
  {
    name: '高',
    code: '1034',
    isSpecial: 1
  },
  {
    name: '长',
    code: '1035',
    isSpecial: 1
  },
  {
    name: '宽',
    code: '1036',
    isSpecial: 1
  },
  {
    name: '肩带长',
    code: '1037',
    isSpecial: 1
  },
  {
    name: '鞋长',
    code: '1038',
    isSpecial: 1
  },
  {
    name: '胸围=横宽*2',
    code: '1039',
    isSpecial: 1
  },
  {
    name: '前挡',
    code: '1040',
    isSpecial: 1
  },
  {
    name: '下裆',
    code: '1041',
    isSpecial: 1
  },
  {
    name: '裤脚宽',
    code: '1042',

  }
]
